// window.onscroll = function() {myFunction()};

// function myFunction() {
//   if (window.pageYOffset >= 1) {
//     document.getElementById("nav_header").classList.add("scroll");
//     document.getElementById("fixed_nav_menu").classList.add("scroll");
//   } else {
//     document.getElementById("nav_header").classList.remove("scroll");
//     document.getElementById("fixed_nav_menu").classList.remove("scroll");
//   }
// }

document.addEventListener('DOMContentLoaded', function () {
  'use strict';
  
  /*---loader---*/
  setTimeout(()=>{
    $('.loader-container').fadeOut(1000);    
    setTimeout(()=>{
      $('html').removeClass('overflow-hidden');
      $('body').addClass('animated');
    },500)
  }, 1000)

  // Get all "navbar-burger" elements
  var $navbarBurgers = Array.prototype.slice.call(document.querySelectorAll('.navbar-burger'), 0);

  // Check if there are any navbar burgers
  if ($navbarBurgers.length > 0) {

    // Add a click event on each of them
    $navbarBurgers.forEach(function ($el) {
      $el.addEventListener('click', function () {

        // Get the target from the "data-target" attribute
        var target = $el.dataset.target;
        var $target = document.getElementById(target);

        // Toggle the class on both the "navbar-burger" and the "navbar-menu"
        $el.classList.toggle('is-active');
        $target.classList.toggle('is-active');

      }, {passive: true});
    });
  }
  var files = document.getElementsByClassName("file-input");
  for (var i = 0; i < files.length; i++) {
    var file = files[i];
    file.onchange = function(){
      var file = this;
      var parent = this.parentNode;
      var parent_id = parent.id;
      if(file.files.length > 0)
      {
       document.getElementById(parent_id).querySelector('.file-name .invisible').value=file.files[0].name;              
     }
   };
 }
 // Dropdowns clickable

 var $dropdowns = getAll('.dropdown:not(.is-hoverable)');

 if ($dropdowns.length > 0) {
  $dropdowns.forEach(function ($el) {
    $el.addEventListener('click', function (event) {
      event.stopPropagation();
      $el.classList.toggle('is-active');
    });
  });

  document.addEventListener('click', function (event) {
    closeDropdowns();
  }, {passive: true});
}

function closeDropdowns() {
  $dropdowns.forEach(function ($el) {
    $el.classList.remove('is-active');
  });
}

  // Close dropdowns if ESC pressed
  document.addEventListener('keydown', function (event) {
    var e = event || window.event;
    if (e.keyCode === 27) {
      closeDropdowns();
    }
  }, {passive: true});

  // Functions

  function getAll(selector) {
    return Array.prototype.slice.call(document.querySelectorAll(selector), 0);
  }


   // Dropdowns clickable
   // $(".progress-bar .progress-position").css("right", $(this).attr("progress-position")+"%");
  //  var width = $(".progress-bar .progress-position").val();
  //  var totalwidth = $(".progress-bar").width();
  //  var labelwidth = $(".progress-bar .progress-position").width();
  //  var diff= ((labelwidth*100)/totalwidth)/2;

  //  $(".progress-bar .progress-position").css("right", (width-diff)+"%");
  //  $( ".progress-bar input.progress-position" ).change(function() {
  //   $(".progress-bar .progress-position").css("right", (width-diff)+"%");
  // });

}, {passive: true});
$('document').ready(function(){
  $('.pageloader').removeClass('is-active');
  
  $('.wizard-footer-right , .wizard-footer-left').click(function() {
    $("html, body").animate({ scrollTop: 0 }, "slow");
    return true;
  });
  $('.panel-container.mobile').on("click",function(){
    if ($(this).hasClass('active')) {
      $(this).removeClass('active');
    }else{
      $('.panel-container.mobile').removeClass('active');
      $(this).addClass('active');
    }
    
  });

  var imgDefer = document.getElementsByTagName('img');
  for (var i=0; i<imgDefer.length; i++) {
    if(imgDefer[i].getAttribute('data-src')) {
      imgDefer[i].setAttribute('src',imgDefer[i].getAttribute('data-src'));
    } 
  }


},{passive: true});

$( document ).ready(function() {
 $( ".modal-open" ).click(function() {
  var modalClass = $(this).attr("traget-modal");
  $(modalClass).addClass('is-active');

  $(modalClass+' .delete-form').attr("action" , $(this).attr("data-url"));
  $(modalClass+' .delete-form .delete-text strong').html($(this).attr("data_name"));
  $(modalClass+' .status-name').html($(this).attr("status-name"));
  $(modalClass+' .user-phone').html($(this).attr("user-phone"));
  $(modalClass+' .user-points').val($(this).attr("user-points"));
  $(modalClass+' .old-data').val($(this).attr("old-data"));
  $(modalClass+" .close-modal" ).click(function(e) {
    e.preventDefault();
    $(modalClass).removeClass('is-active');
    $(modalClass+' .delete-form .delete-text strong').html('');      

  });
});
},{passive: true});






// WEBPACK FOOTER //
// ./resources/assets/js/front/script.js